import Parse from "parse";

export interface TextContentAttributes {
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant: Parse.Object;

  key: string;
  category?: string;

  value_de?: string;
  value_en?: string;
  value_ar?: string;
  value_bg?: string;
  value_ro?: string;
  value_ru?: string;
  value_tr?: string;
  value_uk?: string;

  isRichText?: boolean;
  description?: string;
}

export class TextContent extends Parse.Object<TextContentAttributes> {
  static className = "APP_TextContent";

  constructor(data?: Partial<TextContentAttributes>) {
    super("APP_TextContent", data as TextContentAttributes);
  }

  get key(): string {
    return this.get("key") || "";
  }

  get category(): string | undefined {
    return this.get("category");
  }

  get value_de(): string | undefined {
    return this.get("value_de");
  }

  get value_en(): string | undefined {
    return this.get("value_en");
  }

  get isRichText(): boolean {
    return this.get("isRichText") ?? false;
  }

  /**
   * Helper: Get value for a given language code, fallback to German.
   */
  getValue(lang: string = "de"): string {
    const key = `value_${lang}` as keyof TextContentAttributes;
    return (this.get(key) as string) || this.value_de || "";
  }
}

Parse.Object.registerSubclass("APP_TextContent", TextContent);
